export default __webpack_public_path__ + "static/media/murdoch3.8cf6b847.png";